module.exports = __webpack_public_path__ + "img/logo.16217487.png";